import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { SharedModule } from '../shared/shared.module';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { RouterModule } from '@angular/router';
import { HistoryListComponent } from './components/history-list/history-list.component';

const MAT_MODULES = [
  MatButtonModule,
  MatInputModule,
  MatIconModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatListModule
]


@NgModule({
  declarations: [
    HistoryListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    //...MAT_MODULES
  ],
  providers: [DatePipe],
  exports: [HistoryListComponent]
})
export class HistoryModule { }
